import PopularProducts from "./products/PopularProducts";
import BestSelling from "./products/BestSelling";

const Home = () => {
  return (
    <>
      <PopularProducts />
      <BestSelling />
    </>
  );
};

export default Home;
